import React, { useState, useEffect } from "react";
import axios from 'axios';
import { Table, Button, Tag } from 'antd';
import Loader from '../util/Loader';
import './Main.css';
import TopNav from './TopNav';
import MainNav from './MainNav';
import LoginCheck from '../util/LoginCheck';
import DecodeData from '../util/DecodeData';
import LoginFail from '../util/LoginFail';
import pagiarray from 'paginate-array';
import SelectCenter from "../util/SelectCenter";
import { useSelector, useDispatch } from 'react-redux';
import { faAngleRight, faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from 'moment';
import setup from '../setup';

const today = moment();

export default function Report() {
    const [selectedCenter, setSelectedCenter ] = useState('');
    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [pickMonth, setPickMonth] = useState(today);
    const data = useSelector(state => state.data);
    const dispatch = useDispatch();

    const columns = [
        {
            title : '센터명',
            dataIndex : 'cname',
            key : 'cname'
        },
        {
            title : '강사명',
            dataIndex : 'tname',
            key : 'tname'
        },
        {
            title : '총 평점',
            dataIndex : 'score',
            key : 'score',
            render : (item, record) => {
                let {satisfaction_count, satisfaction_avg, kindness_count, kindness_avg, sincerity_count, sincerity_avg, trust_count, trust_avg, interest_count, interest_avg } = record;
                let total_cnt = parseInt(satisfaction_count) + parseInt(kindness_count) + parseInt(sincerity_count) + parseInt(trust_count) + parseInt(interest_count);
                let total_avg = ((satisfaction_avg*satisfaction_count + kindness_avg*kindness_count + sincerity_avg*sincerity_count + trust_avg*trust_count + interest_avg*interest_count)/total_cnt).toFixed(1)
                return (
                    total_avg + " (" + total_cnt + ")"
                )
            }
        },
        {
            title : '만족도',
            dataIndex : 'satisfaction_avg',
            key : 'satisfaction_avg',
            render : (item, record) => {
                return (
                    item + " (" + record.satisfaction_count + ")"
                )
            }
        },
        {
            title : '친절도',
            dataIndex : 'kindness_avg',
            key : 'kindness_avg',
            render : (item, record) => {
                return (
                    item + " (" + record.kindness_count + ")"
                )
            }
        },
        {
            title : '성실도',
            dataIndex : 'sincerity_avg',
            key : 'sincerity_avg',
            render : (item, record) => {
                return (
                    item + " (" + record.sincerity_count + ")"
                )
            }
        },
        {
            title : '신뢰도',
            dataIndex : 'trust_avg',
            key : 'trust_avg',
            render : (item, record) => {
                return (
                    item + " (" + record.trust_count + ")"
                )
            }
        },
        {
            title : '흥미도',
            dataIndex : 'interest_avg',
            key : 'interest_avg',
            render : (item, record) => {
                return (
                    item + " (" + record.interest_count + ")"
                )
            }
        }
    ];

    function handleSelectedCenter(cid){
        setSelectedCenter(cid);
    }

    function leftBtn(){
        setPickMonth(moment(pickMonth).add(-1, 'months'))
    }

    function rightBtn(){
        if(pickMonth < today){
            setPickMonth(moment(pickMonth).add(1, 'months'))
        }
    }

    function getDataSource(){
        let temp_cid = '';
        if(data.cid !== 'root'){
            temp_cid = data.cid
        }else{
            temp_cid = selectedCenter
        }
        let sdate = moment(pickMonth).format('YYYY-MM-01');
        let edate;
        if(pickMonth < today){
            edate = moment(pickMonth).endOf('month').format('YYYY-MM-DD');
        }else{
            edate = moment(pickMonth).format('YYYY-MM-DD');
        }

        (async function () {
            const api_host = process.env.NODE_ENV === 'development' ? setup.development.api_host : setup.production.api_host;
            const result = await axios.post(api_host + '/hg/rate_stat', {
                cid: temp_cid,
                sdate : sdate,
                edate : edate
            })
            if(result.data){
                setDataSource(result.data);
            }
        })();
    }

    async function main() {
        const result = await LoginCheck(data.url);
        if(result === "Y"){
            const decodeResult = await DecodeData(data.url);
            dispatch({type:'SET', name:"CID", value:decodeResult.cid});
            dispatch({type:'SET', name:"LEVEL", value:decodeResult.level});
            getDataSource();
            setInterval(()=>{setIsLoading(false)}, 300);
        }else{
            LoginFail();
        }
    }

    useEffect(()=>{
        main();   
    },[]);

    useEffect(()=>{
        if(data.cid === "root"){
            getDataSource();
        }
    },[selectedCenter]);

    useEffect(()=>{
        getDataSource();
    },[pickMonth]);

    if (isLoading) return (
        <main className="main-container">
        <TopNav />
        <div className="content-wrapper">
        <MainNav />
        <Loader />
        </div>
        </main>
    )

    return (
        <main className="main-container">
            <TopNav />
            <div className="content-wrapper">
            <MainNav />
            <div className="content-inner">
            <h3>평가리포트</h3>
            <div className="content-component">
                <div className="content-header">
                <div></div>
                <SelectCenter 
                    onSelectedCenter={handleSelectedCenter}
                />
                </div>
                <div className="content-body">
                    <div className="month-range">
                        <a href="#"><Button className="mr-1 btn-secondary" size="sm" onClick={()=>leftBtn()}><FontAwesomeIcon icon={faAngleLeft} /></Button></a>
                        {moment(pickMonth).format('YYYY년 MM월')}
                        <a href="#"><Button className="ml-1 btn-secondary" size="sm" onClick={()=>rightBtn()}><FontAwesomeIcon icon={faAngleRight} /></Button></a>
                    </div>
                    <div className="table-body">
                    <Table dataSource={dataSource} columns={columns}/>
                    </div>
                </div>
            </div>
            </div>
            </div>
        </main>
    )
}